Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.FiltersView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/filters/filters']
  className: 'filters mini-scrollbar'

  initialize: ({session, filtersFactory}) ->
    @filtersFactory = filtersFactory
    @session = session
    @_createAppliedFiltersView()
    @_createUnappliedFiltersView()
    @listenTo(@session, 'session:filterChange', @render)

  _createAppliedFiltersView: ->
    @appliedFiltersView = new Common.Dashboard.Filters.AppliedFiltersView
      session: @session
      filtersFactory: @filtersFactory
    @listenTo(@appliedFiltersView, 'filters:apply', @_applyFilterToSession)

  _createUnappliedFiltersView: ->
    @unappliedFiltersView = new Common.Dashboard.Filters.UnappliedFiltersView
      session: @session
      filtersFactory: @filtersFactory
    @listenTo(@unappliedFiltersView, 'filters:apply', @_applyFilterToSession)

  destroy: ->
    @remove()
    return false

  render: =>
    @$el.html(@template())
    @_renderAppliedFilters()
    @_renderUnappliedFilters()
    @

  _renderAppliedFilters: ->
    @$el.prepend @appliedFiltersView.render().el
    @appliedFiltersView.delegateEvents()

  _renderUnappliedFilters: ->
    @$el.append @unappliedFiltersView.render().el

  _applyFilterToSession: (filter) =>
    compositeFilter = @session.getCompositeFilter()
    compositeFilter.addFilter(filter)
    @session.setCompositeFilter(compositeFilter)
    @session.updateFilters()
